// Date helpers for the task desk views (gantt / calendar).
// Task dates arrive as strings in the user's date format: Jalali
// (1403/05/12) or Gregorian (2024-08-02). Everything is normalised to a
// Gregorian moment at start of day; display uses the Jalali calendar when
// `jalali` is true.
import moment from 'jalali-moment'

export function parseDate (str) {
  if (!str) return null
  const s = String(str).trim().slice(0, 10).replace(/-/g, '/')
  const y = parseInt(s, 10)
  if (!y) return null
  const m = y < 1700 ? moment.from(s, 'fa', 'YYYY/MM/DD') : moment.from(s, 'en', 'YYYY/MM/DD')
  return m.isValid() ? m.locale('en').startOf('day') : null
}

export function today () {
  return moment().locale('en').startOf('day')
}

export function dayKey (m) {
  return m.clone().locale('en').format('YYYY-MM-DD')
}

export function loc (m, jalali) {
  return m.clone().locale(jalali ? 'fa' : 'en')
}

export function fmt (m, pattern, jalali) {
  return m ? loc(m, jalali).format(pattern) : ''
}

export function diffDays (a, b) {
  return Math.round(a.clone().startOf('day').diff(b.clone().startOf('day'), 'days', true))
}

// Friday in Iran, Sat/Sun elsewhere.
export function isWeekend (m, jalali) {
  const d = m.day()
  return jalali ? d === 5 : d === 0 || d === 6
}

// Weeks (arrays of 7 days) covering the month of `cursor`.
export function monthGrid (cursor, jalali) {
  const start = loc(cursor, jalali).startOf('month')
  const end = start.clone().endOf('month')
  const first = start.clone().subtract((start.day() - weekStart(jalali) + 7) % 7, 'days')
  const t = dayKey(today())
  const weeks = []
  let d = first.clone()
  while (weeks.length < 6 && (weeks.length === 0 || d.isSameOrBefore(end, 'day'))) {
    const week = []
    for (let i = 0; i < 7; i++) {
      week.push({
        m: d.clone().locale('en'),
        key: dayKey(d),
        label: loc(d, jalali).format('D'),
        inMonth: d.isSameOrAfter(start, 'day') && d.isSameOrBefore(end, 'day'),
        isToday: dayKey(d) === t,
        weekend: isWeekend(d, jalali),
      })
      d.add(1, 'day')
    }
    weeks.push(week)
  }
  return weeks
}

export function weekStart (jalali) {
  return jalali ? 6 : 0
}

export function weekdayNames (jalali) {
  const d = today()
  const first = d.clone().subtract((d.day() - weekStart(jalali) + 7) % 7, 'days')
  const names = []
  for (let i = 0; i < 7; i++) names.push(loc(first.clone().add(i, 'days'), jalali).format('dd'))
  return names
}

export function monthTitle (m, jalali) {
  return loc(m, jalali).format('MMMM YYYY')
}

export function addMonths (m, n, jalali) {
  return loc(m, jalali).add(n, 'month').locale('en')
}
